<template lang="html">
  <div class="border-right" id="sidebar-wrapper">
    <div class="header-sidebar" slot="header">
        <img :src="basepath+'/unodc_logo.png'" alt="" width="200" />
    </div>
    <div class="list-group list-group-flush mb-3">
      
        <router-link to="/dashboard/Advisor/advisordashboard" class="list-group-item list-group-item-action">
            <i class="material-icons">home</i> Dashboard
        </router-link>
        <router-link to="/dashboard/Advisor/conductedTraining" class="list-group-item list-group-item-action">
            <i class="material-icons">assignment_turned_in</i> Un-Assigned Training <span class="badge badge-danger pl-2 pr-2" style="font-size:14px">{{Counter}}</span>
        </router-link>
        <div>
            <div slot="header" class="list-group-item list-group-item-action" id="mybutton"><i class="material-icons pr-1">brightness_low</i><b>Training Management</b>
            </div>

            <ul>
                 <router-link to="/dashboard/Advisor/questionbankarchives" class="list-group-item list-group-item-action">
              <i class="material-icons">remove</i> Question Bank
          </router-link>

          <router-link to="/dashboard/Advisor/KnowledgeBaseArchives" class="list-group-item list-group-item-action">
              <i class="material-icons">remove</i> Knowledge Base
          </router-link>
         </ul>
        </div>
         <div>
            <router-link to="/dashboard/Advisor/reportsAdvisorAll"  slot="header" class="list-group-item list-group-item-action" id="mybutton">
            <i class="material-icons pr-1">chrome_reader_mode</i
            ><b> Reports</b>
             </router-link>
            <!-- <ul>
                 <router-link to="/dashboard/advisor/ReportsAdvisorGraphs" class="list-group-item list-group-item-action">
                  <i class="material-icons">remove</i>  Statistics & Graphs
                   
                  </router-link>
                  <router-link to="/dashboard/advisor/ReportsFilterAdvisor" class="list-group-item list-group-item-action">
                   <i class="material-icons">remove</i> Trainings
                    
                  </router-link>
                  <router-link to="/dashboard/Advisor/thematicAreaAdvisor" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Thematic Area
                    
                  </router-link>
                    <router-link to="/dashboard/Advisor/subprogramListAdvisor" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Sub Program Wise
                    
                  </router-link>
                    <router-link to="/dashboard/Advisor/projectListAdvisor" class="list-group-item list-group-item-action">
                  <i class="material-icons">remove</i> Project Wise
                    
                  </router-link>
            </ul> -->
        </div>
    </div>
</div>
</template>

<script>
import { bus } from "../../../main";
import axios from "axios";
export default {
  data: () => ({
    active: true,
    basepath: localStorage.getItem("BASE_PATH"),
    Counter: 0
  }),
  created() {
    bus.$on("sidebarStatus", data => {
      this.active = data;
    });
  },
  mounted() {
    // Set the initial number of items
    this.unassignedTrainingsCount();
  },
  methods: {
    isSidebar() {
      bus.$emit("sidebarStatus", this.active);
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    unassignedTrainingsCount: function unassignedTrainingsCount() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/advisor/unassigned/count-training/" +
            JSON.parse(localStorage.getItem("currentUser")).id
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data && response.data.unsignedTrainingCount) {
            this.Counter = response.data.unsignedTrainingCount;
          }
        });
    }
  }
};
</script>

<style scoped>
/*!
 * Start Bootstrap - Simple Sidebar (https://startbootstrap.com/template-overviews/simple-sidebar)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-simple-sidebar/blob/master/LICENSE)
 */

body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */
</style>